// Vendors
import axios from 'axios';

// Src
import Config from '@/config';
import { AuthenticationCredentials, LoggedUserInfo, UserDetail } from '../types/authenticationTypes';

export const authenticationAPI = '/auth/login';
export const getLoggedUserAPI = '/users';
export const refreshTokenAPI = '/auth/access_token';

export const apiRequest = axios.create({
    baseURL: Config.BACKEND_API_URL || 'http://localhost:8080',
});

export function authenticationLogin(credentials: AuthenticationCredentials) {
    return apiRequest.post<LoggedUserInfo>(authenticationAPI, credentials);
}

export function authenticationRefreshToken(refresh_token: string) {
    return apiRequest.post(refreshTokenAPI, {
        grant_type: 'refresh_token',
        refresh_token,
    });
}

export function authenticationGetLoggedUser(userId: number, access_token: string) {
    return apiRequest.get<{
        detail: UserDetail;
    }>(`${getLoggedUserAPI}/${userId}`, {
        headers: {
            Authorization: `Bearer ${access_token}`,
        },
    });
}
